import React from "react";
import axios from "axios";
import { useLoaderData } from "@remix-run/react";
import { json, redirectDocument } from "@remix-run/cloudflare";

// Components
import Hero from "../components/blog/blogsingle/Hero";
import Content from "../components/blog/blogsingle/Content";
import Share from "../components/blog/blogsingle/Share";
import Breadcrumbs from "../components/utils/Breadcrumb";

export async function loader({ request, context }) {
  const searchParams = new URL(request.url);
  const { pathname } = searchParams;

  try {
    const blogs = await axios
      .get(
        `${context.cloudflare.env.STRAPI_BASE_URL}/api/blogs?filters[seo][canonicalURL][$eq]=${pathname}&populate[0]=image&populate[1]=seo.metaImage&populate[2]=seo.metaSocial&populate[3]=seo.metaSocial.image`,
        {
          headers: {
            Authorization: `Bearer ${context.cloudflare.env.STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => res.data);
    const blog = blogs.data?.[0]?.attributes;

    if (!blog) {
      return redirectDocument("/404");
    }

    return json({ blog });
  } catch (error) {
    console.error(error);
    return redirectDocument("/404");
  }
}

export const handle = {
  breadcrumb: ({ match }) => {
    const { blog } = match.data;

    return blog?.title;
  },
};

export const meta = ({ data }) => {
  const { blog } = data;
  const { seo } = blog;

  const {
    canonicalURL,
    keywords,
    metaDescription,
    metaTitle,
    structuredData,
    metaSocial,
  } = seo;

  const twitter = metaSocial?.find((s) => s.socialNetwork === "Twitter");
  const facebook = metaSocial?.find((s) => s.socialNetwork === "Facebook");

  return [
    { title: metaTitle },
    {
      name: "keywords",
      content: keywords,
    },
    {
      name: "description",
      content: metaDescription,
    },
    {
      property: "og:title",
      content: facebook?.title || metaTitle,
    },
    {
      property: "og:description",
      content: facebook?.description || metaDescription,
    },
    {
      property: "og:url",
      content: canonicalURL,
    },
    {
      property: "og:image",
      content: facebook?.image?.data?.attributes?.formats?.medium?.url,
    },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
    {
      name: "twitter:title",
      content: twitter?.title || metaTitle,
    },
    {
      name: "twitter:description",
      content: twitter?.description || metaDescription,
    },
    {
      name: "twitter:image",
      content: twitter?.image?.data?.attributes?.formats?.medium?.url,
    },
    { name: "twitter:site", content: "@headlockr" },
    {
      "script:ld+json": {
        structuredData,
      },
    },
  ];
};

export default function Index() {
  const { blog } = useLoaderData();

  return (
    <div className="container pb-5 pt-0">
      <div className="row pt-0 px-lg-10 d-flex flex-column align-items-center text-center text-lg-start">
        <Hero blog={blog} />
        <div className="col-12 col-lg-10">
          <Breadcrumbs />
          <Content blog={blog} />
        </div>
        <div className="col-12 col-lg-8 d-flex justify-content-center">
          <Share
            title={blog?.title}
            url={`${"https://headlockr.io" + blog?.seo?.canonicalURL}`}
            blog={blog}
            image={blog?.image?.data?.attributes?.url}
          />
        </div>
      </div>
    </div>
  );
}
